import { getTheme } from 'mol-ui';
import styled from 'styled-components';

export const Text = styled.span`
    color: ${ getTheme('textColor') };
    font-size: 11px;
`;
